import React, { Component } from 'react';
import styled from 'styled-components';
import { func } from 'prop-types';

import Dropdown from 'apps/journey/components/dropdown';
import JourneyCard from 'library/components/journey-card';
import Collapsable from 'library/components/collapsable';
import Caret from 'library/icons/caret.svg';
import RemoveSvg from 'library/icons/x-in-circle.svg';
import Env from 'library/util/env';
import { resolve } from 'library/helpers/path-resolver';

const StyledFilterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledJourneyCard = styled(JourneyCard)`
  transition: all .2s ease-in-out;

  &:hover {
    box-shadow: 0px 6px 9px 4px rgba(0,0,0,0.2)
  }
`;

const StyledSearchFilter = styled.div`
  display: flex;
  flex-direction: column;
  transition: all .2s ease-in-out;
  overflow: hidden;
`;

const StyledFilterHeading = styled.div`
  display: flex;
  flex-directon: row;
  justify-content: space-between;

  span {
    color: #595959;
    cursor: pointer;
    font-family: Lato;
    font-size: 18px;
    font-weight: bold;

    &:first-child {
      flex: 1;
    }
  }

  svg {
    color: #595959;
    ${props => props.collapsed ? `` : `transform: rotate(180deg)`};
    transition: all .2s ease-in-out;
  }
`;

const StyledFilters = styled.div`
  display: flex;
  justify-content: space-between;
  transition: all .3s ease-in-out;
  padding-top: 1em;
  cursor: pointer;

  ${props => props.collapsed ? `
      opacity: 0;
    ` : `
      opacity: 1;
    `}

  > * {
    flex: 1;
    margin-right: 1em;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const StyledAppliedFilters = styled.div`
    display: flex;
    flex-direction: row;
    padding: 1em 0;

    div {
      padding: .5em;
      margin: .5em .5em .5em 0;
    }
`;

const StyledFilter = styled.div`
  background-color: #D2E4EB;
  border-radius: 4px;
  display: flex;

  span {
    color: #595959;
    font-family: Lato;
    font-size: 14px;
    flex: 1;
    padding-right: 2em;
  }
  svg {
    height: 100%;
    cursor: pointer;
  }
`;

class SearchFilter extends Component {
  static propTypes = {
    setFilters: func
  }

  state = {
    collapsed: true,
    appliedFilters: {},
    filters: []
  }

  componentDidMount = async () => {
    await this.getFilters();
  }

  getFilters = async () => {
    try {
      const response = await fetch( `${Env.get(`__SEARCH_URL__`, 'https://search.staging.pairin.com')}/courses/high-school/filters`)
        .then(res => res.json());
      const filters = resolve(response, 'schools', [])
        .map(filter => ({
          key: filter,
          value: filter
        }));

      this.setState({
        filters
      });
    } catch (e) {
      console.error(e);
    }
  };

  handleChange = (e) => {
    this.setState({
      appliedFilters: {
        ...this.state.appliedFilters,
        [e.target.name]: e.target.value
      },
      collapsed: true
    });
    this.props.setFilters({
      [e.target.name]: e.target.value
    });
  };

  render = () => (
    <StyledFilterSection>
      <AppliedFilters
        appliedFilters={this.state.appliedFilters}
        handleChange={this.handleChange}
      />
      <StyledJourneyCard min-width="666px">
        <StyledSearchFilter>
          <StyledFilterHeading
            onClick={() => this.setState({ collapsed: !this.state.collapsed })}
            collapsed={this.state.collapsed}
          >
            <span>Search Filters</span>
            <span><Caret /></span>
          </StyledFilterHeading>
          <Collapsable collapsed={this.state.collapsed}>
            <StyledFilters collapsed={this.state.collapsed}>
              <Dropdown
                label="School"
                key="school"
                name="school"
                value={this.state.appliedFilters['school']}
                options={this.state.filters}
                onChange={this.handleChange}
              />
            </StyledFilters>
          </Collapsable>
        </StyledSearchFilter>
      </StyledJourneyCard>
    </StyledFilterSection>
  );
};

const AppliedFilters = ({ appliedFilters, handleChange }) => {
  const filters = Object.keys(appliedFilters)

  const removeFilter = (filter) => {
    handleChange({
      target: {
        name: filter,
        value: ''
      }
    });
  };

  const mapAppliedFilters = (filter, i) => appliedFilters[filter] ? (
    <StyledFilter key={i}>
      <span>{appliedFilters[filter]}</span>
      <RemoveSvg onClick={() => removeFilter(filter)}/>
    </StyledFilter>
  ) : null;

  return (
    <StyledAppliedFilters>
      {filters.map(mapAppliedFilters)}
    </StyledAppliedFilters>
  );
};

export default SearchFilter;
